import { Theme } from "@material-ui/core";

import { Green, GreyDark } from "assets/colors";

const mobileBreakpoint = "xs";
const tabletBreakpoint = "sm";

const styles = (theme: Theme) =>
  ({
    content: {
      width: "100%",
      flexGrow: 1,
      backgroundColor: theme.palette.background.default,
      padding: 24,
      height: "calc(100% - 56px)",
      [theme.breakpoints.up("sm")]: {
        height: "calc(100vh - 64px)",
      },
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },

    // Common //
    ReactBackgroundSlider: {
      height: "100%",
      width: "100%",
      position: "absolute",
      top: "0px",
      left: "0px",
      color: "transparent",
      backgroundSize: "cover",
      backgroundPosition: "center center",
      backgroundRepeat: "no-repeat",
      opacity: "0",
      zIndex: -1000,
      margin: "0",
    },
    fieldProLoginLogo: {
      maxWidth: 158,
      maxHeight: 48,
    },
    LoginPage: {
      backgroundColor: theme.palette.primary.main,
      display: "grid",
      gridTemplateColumns: "70vw 30vw",
      overflow: "hidden",
    },
    LoginPageCard: {
      backgroundColor: "white",
      overflowY: "auto",
    },
    GoogleButton: {
      //using !important to override react-google-button default
      columnGap: "8px",
      elevation: "0",
      backgroundColor: "transparent",
      textAlign: "center",
      border: "1px solid rgba(184, 184, 184, 1) !important",
      boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.05) !important",
      fontFamily: "BasierCircle",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      color: "black",
      borderRadius: "4px !important",
      fontWeight: "bold",
      "& > *": {
        padding: "0px !important",
        margin: "0px !important",
      },
      "& div:first-of-type": {
        display: "contents",
      },
      "& span:first-of-type": {
        fontWeight: "bold !important",
        fontSize: "16px",
      },
    },
    LoginPageLeftPanel: {
      background: theme.palette.primary.main,
      [theme.breakpoints.down(mobileBreakpoint)]: {
        // mobile
        width: "100%",
        height: "40%",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      },
      [theme.breakpoints.up(tabletBreakpoint)]: {
        // tablet
        width: "40%",
        height: "100%",
        float: "left",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
    },
    LeftPanelContent: {
      [theme.breakpoints.down(mobileBreakpoint)]: {
        // mobile
        width: "100%",
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
      },
    },
    LoginLogoContainer: {
      margin: "auto",
      width: "150px",
      height: "150px",
    },
    LoginPageRightPanel: {
      background: "white",
      paddingTop: "50px",
      [theme.breakpoints.down(mobileBreakpoint)]: {
        // mobile
        width: "100%",
        height: "60%",
        position: "relative",
        justifyContent: "center",
        alignItems: "center",
      },
      [theme.breakpoints.up(tabletBreakpoint)]: {
        // tablet
        width: "60%",
        height: "100%",
        background: "white",
        float: "right",
      },
    },
    LoginFormPasswordForgotten: {
      color: Green,
      fontSize: "16px",
      fontWeight: "bold",
      lineHeight: "1.13",
      letterSpacing: "-0.35px",
      textAlign: "right",
      "& > *": {
        fontWeight: "bold",
        fontSize: "16px",
      },
    },
    LoginButtonContainer: {
      marginTop: "32px",
      display: "flex",
      flexDirection: "column",
      rowGap: "10px",
    },
    FormContainer: {
      width: "80%",
      margin: "auto",
      display: "flex",
      flexDirection: "column",
      marginTop: "10px",
      "&  input , button": {
        height: "50px",
        width: "100%",
      },
      "& input": {
        paddingLeft: "10px",
        paddingRight: "10px",
        borderRadius: "2px !important",
        border: `solid 1px ${GreyDark} !important`,
      },
      "& input[type='password']::placeholder": {
        fontWeight: "600",
        letterSpacing: "1px",
      },
    },
    TitleLogin: {
      color: "#124e5d",
      fontWeight: "bold",
      lineHeight: "1.25",
      fontSize: "32px",
    },
    SubTitleLogin: {
      color: "#124e5d",
      fontSize: "16px",
      marginTop: "13px",
      fontWeight: 500,
      lineHeight: "1.25",
    },
    SubTitle2Login: {
      color: "#2c2c2c",
      fontSize: "16px",
      marginTop: "13px",
      fontWeight: "bold",
      lineHeight: "1.33",
      fontStretch: "normal",
      fontStyle: "normal",
    },
    Image: {
      maxWidth: "100%",
    },
    ProgressContainer: {
      display: "block",
      marginLeft: "auto",
      marginRight: "auto",
      width: "50px",
    },
    loginFormContainer: {
      height: "100vh",
      position: "relative",
      overflow: "scroll",
    },
    formContainer: {
      display: "grid",
      gridTemplateColumns: "1fr 30%",
      [theme.breakpoints.down("sm")]: {
        gridTemplateColumns: "1fr 0px",
      },
    },
    bookDemoLink: {
      fontWeight: "700",
      color: Green,
      "&:hover": {
        color: Green,
      },
    },
  }) as const;

export default styles;
